import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaFileAlt, FaChevronRight } from 'react-icons/fa';
import { Page, PageHeader, Card, Badge, Alert, Loading, EmptyRow, formatDate, initials } from '../../ui';
import { api } from '../../ui/api';
import { documentLink } from '../../session';

const verificationTone = (v) => ({ Verified: 'green', Rejected: 'red' }[v] || 'amber');

const VendorDetails = () => {
  const { id } = useParams();
  const [vendor, setVendor] = useState(null);
  const [staff, setStaff] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api(`/vendor/vendor/${id}`).then((d) => setVendor(d.vendor)).catch((e) => setError(e.message));
    api(`/staff/get_staff_by_vendor/${id}`).then(setStaff).catch(() => setStaff([]));
  }, [id]);

  if (error) return <Page><Alert>{error}</Alert></Page>;
  if (!vendor) return <Page><Loading /></Page>;

  return (
    <Page>
      <PageHeader
        title={vendor.company_name}
        subtitle={`Partner since ${formatDate(vendor.created_at)}`}
        back={{ to: '/manage-vendors', label: 'Vendors' }}
        actions={<Badge tone={vendor.is_active ? 'green' : 'gray'}>{vendor.is_active ? 'Active' : 'Deactivated'}</Badge>}
      />
      <div className="grid grid-sidebar">
        <div className="stack">
          <Card title="Company">
            <dl className="kv">
              <div><dt>Email</dt><dd>{vendor.company_email}</dd></div>
              <div><dt>Phone</dt><dd>{vendor.company_phone}</dd></div>
              <div><dt>Contact person</dt><dd>{vendor.representative_name}</dd></div>
              <div><dt>Contact phone</dt><dd>{vendor.representative_phone}</dd></div>
            </dl>
          </Card>
          <Card title="Field staff" hint={staff ? `${staff.length} on the team` : undefined} flush>
            {!staff ? <Loading /> : (
              <div className="table-wrap">
                <table className="table stack-sm">
                  <thead><tr><th>Name</th><th>Phone</th><th>Verification</th><th /></tr></thead>
                  <tbody>
                    {staff.length ? staff.map((s) => (
                      <tr key={s.id}>
                        <td data-label="Name">
                          <div className="row" style={{ flexWrap: 'nowrap' }}>
                            <div className="avatar">{initials(s.name)}</div>
                            <span className="strong">{s.name}</span>
                          </div>
                        </td>
                        <td data-label="Phone">{s.phone_number}</td>
                        <td data-label="Verification"><Badge tone={verificationTone(s.verification)}>{s.verification || 'Pending'}</Badge></td>
                        <td className="actions-cell"><Link className="icon-btn" to={`/staff/${s.id}`}><FaChevronRight /></Link></td>
                      </tr>
                    )) : <EmptyRow cols={4}>No field staff added yet.</EmptyRow>}
                  </tbody>
                </table>
              </div>
            )}
          </Card>
        </div>
        <Card title="Documents">
          {vendor.documents && vendor.documents.length ? (
            <div className="stack" style={{ gap: 8 }}>
              {vendor.documents.map((doc, i) => (
                <a key={i} className="doc-tile" href={documentLink(doc.url)} target="_blank" rel="noopener noreferrer">
                  <FaFileAlt />
                  <span className="doc-name">Document {i + 1}</span>
                  <span className="small muted">{formatDate(doc.upload_date)}</span>
                </a>
              ))}
            </div>
          ) : <p className="muted">No documents uploaded.</p>}
        </Card>
      </div>
    </Page>
  );
};

export default VendorDetails;
